import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: 0,
      marginBottom: 0
    }
  },
  props: {
    duration: {
      type: Number,
      default: 0.5
    }
  },
  methods: {
    clearValues(el) {
      el.style.height = ''
      this.setBox(el, '')
      el.style.transition = ''
      el.style.overflow = ''
    },
    calcAndSetPaddingMargin() {
      if (this.$slots.default && this.$slots.default[0].elm) {
        const el = this.$slots.default[0].elm
        const css = window.getComputedStyle(el, null)
        this.paddingTop = css.paddingTop
        this.paddingBottom = css.paddingBottom
        this.marginTop = css.marginTop
        this.marginBottom = css.marginBottom
      }
    },
    setBox(el, boxValues) {
      const isObj = typeof boxValues === 'object'
      el.style.paddingTop = isObj ? boxValues.paddingTop : boxValues
      el.style.paddingBottom = isObj ? boxValues.paddingBottom : boxValues
      el.style.marginTop = isObj ? boxValues.marginTop : boxValues
      el.style.marginBottom = isObj ? boxValues.marginBottom : boxValues
    },
    setValues(el, height, boxValues) {
      el.style.transition = `all ${this.duration}s linear`
      el.style.overflow = 'hidden'
      el.style.height = `${height}px`
      if (boxValues !== undefined) {
        this.setBox(el, boxValues)
      }
    }
  },
  render(createElement) {
    const vm = this
    const data = {
      props: { name: 'slide-transition' },
      on: {
        beforeEnter(el) {
          vm.setValues(el, 0)
        },
        enter(el, done) {
          // should just need the beforeEnter call to setValues, but for some reason it is not
          // working that way.  Only seems to work if set in both places.
          const height = el.scrollHeight
          vm.setValues(el, 0, 0)
          // TODO: still have issue with padding and/or margin not transitioning on enter
          vm.setValues(el, height, {
            paddingTop: vm.paddingTop,
            paddingBottom: vm.paddingBottom,
            marginTop: vm.marginTop,
            marginBottom: vm.marginBottom
          })
          done()
        },
        afterEnter(el) {
          setTimeout(() => {
            vm.clearValues(el)
            vm.calcAndSetPaddingMargin()
          }, (vm.duration * 1000))
        },
        beforeLeave(el) {
          vm.setValues(el, el.offsetHeight)
        },
        leave(el) {
          // should just need the beforeLeave call to setValues, but for some reason it is not
          // working that way.  Only seems to work if set in both places.
          vm.setValues(el, el.offsetHeight)
          // now set to 0
          vm.setValues(el, 0, 0)
        },
        afterLeave(el) {
          vm.clearValues(el)
        }
      },
      bind: { css: false }
    }
    return createElement('transition', data, this.$slots.default)
  },
  mounted() {
    this.calcAndSetPaddingMargin()
  }
})
